module.exports = __webpack_public_path__ + "static/media/like.a0921fe3.svg";